import { getApi } from '../apiClient';

export async function sendToSConsent({
  consentGiven
}: {
  consentGiven: boolean;
}): Promise<void> {
  const { data } = await getApi().put<void>('/consents/terms_of_service_consent', {
    consent_given: consentGiven
  });

  return data;
}

export async function sendMarketingConsent({
  consentGiven
}: {
  consentGiven: boolean;
}): Promise<void> {
  const { data } = await getApi().put<void>('/consents/marketing_consent', {
    consent_given: consentGiven
  });

  return data;
}

export async function sendCookiesConsent({
  consentGiven
}: {
  consentGiven: boolean;
}): Promise<void> {
  const { data } = await getApi().put<void>('/consents/cookies_consent', {
    consent_given: consentGiven
  });

  return data;
}

export async function sendResearchConsent({
  consentGiven
}: {
  consentGiven: boolean;
}): Promise<void> {
  const { data } = await getApi().put<void>('/consents/research_consent', {
    consent_given: consentGiven
  });

  return data;
}

export async function sendThirdStateConsent({
  consentGiven
}: {
  consentGiven: boolean;
}): Promise<void> {
  const { data } = await getApi().put<void>('/consents/third_state_consent', {
    consent_given: consentGiven
  });

  return data;
}

export async function sendLegalGroundsConsent(): Promise<void> {
  const { data } = await getApi().post<void>('/legal_grounds/consent');

  return data;
}
